export interface Endpoint {
  [key: string]: string
}

const isDev = process.env.NODE_ENV !== 'production'
const servicesBaseUrl = isDev ? 'https://gb.dev.gb.ru' : 'https://gb.ru'

let API_UI_V1 = '/api/ui/v1'
let API_V2 = '/api/v2'
let API_UI_V2 = '/api/ui/v2'
let API_PRICING = 'https://pricing.gb.ru/api'
const API_ORDERS = 'https://orders.gb.ru'
const API_CLAIMS = 'https://claims.gb.ru'
let API_AUTH_V1 = 'https://gb.ru/api/auth/v1'
let API_CAREER_V1 = 'https://gb.ru/api/career/v1'
let API_ADVCAKE_V1 = 'https://gb.ru/api/advcake/v1'

let API_STAGE = ''

// @ts-ignore
if (process.env.NODE_ENV === 'development') {
  API_STAGE = 'https://staging18.staging.gb.ru'
  API_UI_V1 = `https://gb.dev.gb.ru${API_UI_V1}`
  API_UI_V2 = `https://gb.dev.gb.ru${API_UI_V2}`
  API_V2 = `https://gb.ru${API_V2}`
  API_PRICING = 'https://pricing.gb.ru/api'
  API_AUTH_V1 = 'https://gb.dev.gb.ru/api/auth/v1'
  API_CAREER_V1 = 'https://gb.dev.gb.ru/api/career/v1'
  API_ADVCAKE_V1 = 'https://gb.dev.gb.ru/api/advcake/v1'
}

export const endpoints: Endpoint = {
  categories: `${API_UI_V1}/main/categories`,
  shortPrograms: `${API_UI_V1}/main/shortPrograms`,
  longPrograms: `${API_UI_V1}/main/longPrograms`,
  events: `${API_UI_V1}/main/events`,
  posts: `${API_UI_V1}/main/posts`,
  postsV2: `${API_UI_V2}/main/posts`,
  comments: `${API_UI_V2}/main/comments`,
  statistics: `${API_UI_V1}/main/statistics`,
  tests: `${API_UI_V1}/main/tests`,
  feedbacks: `${API_UI_V1}/main/feedbacks`,
  vacancies: `${API_UI_V1}/main/vacancies`,
  navigation: `${API_UI_V2}/navigation`,
  auth: `${API_V2}/auth`,
  users: `${API_AUTH_V1}/user`,
  availableBlocks: `${API_UI_V1}/assembly-pages`,
  jobs: `${API_CAREER_V1}/vacancies`,
  employer: `${API_CAREER_V1}/projects`,
  loyalty: `${API_ADVCAKE_V1}`,
  constructorDictionaries: `${API_PRICING}/dictionaries`,
  product: `${API_PRICING}`,
  order: `${API_ORDERS}/api/v2/update-order`,
  orderParams: `${API_ORDERS}/api/v2/get-order-params`,
  claims: `${API_CLAIMS}/api/v2/services/webflow/create_claim`,
  specializations: `${API_PRICING}/pim-specializations`,
  techSpecializations: `${API_PRICING}/pim-tech-specializations`,
  pimDirections: `${API_PRICING}/pim-directions`,
  education: `${API_STAGE}/api/v2/education/student`,
  professions: `${API_STAGE}/api/internal/order_pims`,
  nearLesson: `${API_STAGE}/api/internal/education/nearest_lesson`,
  lesson: `${API_STAGE}/api/v2/lessons`,
  educationOnboarding: `${servicesBaseUrl}/api/lms/v1/education/onboarding`,
  teacherPopup: `${servicesBaseUrl}/api/marketing/v1/popup`
}
